var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dbe993b1ed11a0b01d4f3b8e14e8e6d1e29fb740"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["replai-platform-frontend@replai"]={id:"dbe993b1ed11a0b01d4f3b8e14e8e6d1e29fb740"};
      